import { Color } from '@util/enums';
import React from 'react';
import Input from '../input/Input';
function FormInput(_a) {
    var label = _a.label, _b = _a.name, name = _b === void 0 ? '' : _b, value = _a.value, error = _a.error, htmlFor = _a.htmlFor, _c = _a.type, type = _c === void 0 ? 'text' : _c, _d = _a.whiteBg, whiteBg = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, onChange = _a.onChange;
    var style = {};
    if (whiteBg) {
        style.backgroundColor = 'white';
    }
    return (React.createElement("div", null,
        React.createElement("label", { htmlFor: htmlFor !== null && htmlFor !== void 0 ? htmlFor : name, style: { fontSize: 12, color: 'black' } }, label),
        React.createElement(Input, { disabled: disabled, type: type, name: name, onChange: onChange, value: value, style: style }),
        React.createElement("div", { style: { width: '100%', height: 10 } },
            React.createElement("span", { style: { color: Color.RED, fontSize: 10 } }, error))));
}
export default FormInput;
